export default "__VITE_ASSET__DXJ7Nwxg__"